import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services';
import { PlanService } from '../services/plan.service';

@Injectable({
    providedIn: 'root'
})
export class SignupGuard  {

    memoryStorage;
    guest;

    constructor(private router: Router, private storageService: StorageService, private planService: PlanService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const userSelectedPlan = this.storageService.getSessionStore('selectedPlanData');
        const planId = state.root.queryParams?.plan_id;
        if (((userSelectedPlan == null || !Object.keys(userSelectedPlan)?.length) && !planId) && this.planService?.plansLength) {
            this.router.navigateByUrl('/auth/plan');
            return false;
        } else {
            return true;
        }
    }
}
